import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-[#FAF8F5] py-12 border-t border-stone-200">
      <div className="max-w-7xl mx-auto px-6 text-center">
        <div className="flex flex-col items-center">
          {/* Logo ou Elemento Visual Reduzido */}
          <div className="h-8 w-px bg-gradient-to-b from-transparent via-amber-800/30 to-transparent mb-6" />
          
          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-6">
            <p className="font-serif text-[10px] tracking-[0.3em] text-stone-400 uppercase">
              Juiz de Fora / MG
            </p>
            <span className="hidden md:block w-1 h-1 rounded-full bg-stone-300" />
            <h4 className="text-stone-800 font-serif text-lg italic">
              Rua Delfim Moreira, 125 — Centro
            </h4>
          </div>

          <div className="pt-6 border-t border-stone-100 w-full max-w-xs">
            <p className="text-[9px] uppercase tracking-[0.4em] font-bold text-stone-300">
              UniPET Premium © 2026
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;